import { TDay } from 'src/api/getMenu/types';
import { ICategoryResponse } from 'src/api/getCategories/types';
import { ICategory, IMealtime } from 'src/types/mealtimes.types';

export enum MealtimeSteps {
  AddMealtimes = 0,
  AssignCategory = 1,
}

export interface IMealtimeDetailsFlow {
  menuId: string;
  mealtimes: IMealtime[];
  onModalClose: () => void;
}

export interface IMealtimeDetailsModal extends IMealtimeDetailsFlow {
  isModalOpen: boolean;
}

export interface IMealtimeView {
  onSuccess: () => void;
  setMealtimeId?: (value: string) => void;
  menuId: string;
  mealtimes: IMealtime[];
  mealtime?: IMealtime;
  onModalClose: () => void;
  type: 'edit' | 'create';
}

export interface IMealtimeDailyValues {
  start_time: string;
  end_time: string;
  enabled: boolean;
}

export type TMealtimeValues = Record<TDay, IMealtimeDailyValues>;

export interface IFormValues {
  name: string;
  schedules: TMealtimeValues;
  selectedFields?: string;
}

export interface IAssignCategoriesView {
  categoriesData: ICategoryResponse[];
  closeModal: () => void;
  mealtimeId: string;
  menuId: string;
  preselectedCategories?: ICategory[];
}

export type TMealtimesStep = 'add-mealtimes' | 'assign-category';
